import { useEffect, useState } from 'react'
import { promoMessages } from '@/api/mock/fixtures'
import { useLocalStorage } from '@/hooks/useLocalStorage'
import { CloseIcon } from '@/components/ui/icons'

/**
 * Tarja amarela abaixo do cabeçalho.
 *
 * Alterna entre as mensagens promocionais e some de vez quando o usuário fecha
 * (a escolha é lembrada no navegador).
 *
 * TODO(backend): trocar `promoMessages` por um endpoint de campanhas quando
 * houver painel para editá-las.
 */
export function PromoBanner() {
  const [dismissed, setDismissed] = useLocalStorage('mp.promo_dismissed', false)
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (dismissed || promoMessages.length <= 1) return
    const timer = setInterval(
      () => setIndex((current) => (current + 1) % promoMessages.length),
      7000,
    )
    return () => clearInterval(timer)
  }, [dismissed])

  if (dismissed) return null

  const message = promoMessages[index]

  return (
    <div className="relative bg-accent">
      <div className="mx-auto flex max-w-[1200px] items-center justify-center gap-3 px-12 py-2.5">
        <p className="text-center text-[13px] font-medium text-ink">
          <span aria-hidden="true" className="mr-1.5">
            {message.icon}
          </span>
          {message.text}
        </p>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Fechar aviso"
          className="absolute right-4 rounded p-1 text-ink/70 transition-colors hover:bg-black/10 hover:text-ink"
        >
          <CloseIcon className="size-4" />
        </button>
      </div>
    </div>
  )
}
